/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelPaymentDto
 */
export interface CancelPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof CancelPaymentDto
     */
    terminalId: string;
    /**
     * 
     * @type {string}
     * @memberof CancelPaymentDto
     */
    paymentReference: string;
}

/**
 * Check if a given object implements the CancelPaymentDto interface.
 */
export function instanceOfCancelPaymentDto(value: object): value is CancelPaymentDto {
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    return true;
}

export function CancelPaymentDtoFromJSON(json: any): CancelPaymentDto {
    return CancelPaymentDtoFromJSONTyped(json, false);
}

export function CancelPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelPaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'terminalId': json['terminalId'],
        'paymentReference': json['paymentReference'],
    };
}

export function CancelPaymentDtoToJSON(json: any): CancelPaymentDto {
    return CancelPaymentDtoToJSONTyped(json, false);
}

export function CancelPaymentDtoToJSONTyped(value?: CancelPaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'terminalId': value['terminalId'],
        'paymentReference': value['paymentReference'],
    };
}

